export default [
  { value: '15%', label: '15%' },
  { value: '20%', label: '20%' },
  { value: '25%', label: '25%' },
  { value: '30%', label: '30%' },
  { value: 'Maximum', label: 'Maximum' },
];
